import { useEffect } from "react";
import { toast } from "sonner";

/**
 * In a popout window opened via Office.context.ui.displayDialogAsync,
 * request the current state from the parent task pane and apply it.
 * Bypasses localStorage partitioning by using Office Dialog messaging.
 */
const usePopoutBridge = ({
  enabled,
  onState,
}) => {
  useEffect(() => {
    if (!enabled) return;
    if (typeof window === "undefined") return;

    let stopped = false;
    let retryTimer = null;

    const setup = () => {
      const Office = window.Office;
      if (!Office?.onReady) {
        retryTimer = setTimeout(setup, 300);
        return;
      }
      Office.onReady(() => {
        if (stopped) return;
        try {
          // Listen for state pushed by the parent
          Office.context?.ui?.addHandlerAsync?.(
            Office.EventType.DialogParentMessageReceived,
            (arg) => {
              try {
                const msg = JSON.parse(arg.message);
                if (msg.type === "state" && onState) {
                  console.log("[Popout] state received from parent");
                  onState(msg.payload || {});
                }
              } catch (e) {
                console.warn("[Popout] parse error:", e);
              }
            }
          );
          // Ask parent for state
          Office.context?.ui?.messageParent?.(
            JSON.stringify({ type: "request-state" })
          );
          console.log("[Popout] requested state from parent");
        } catch (e) {
          console.warn("[Popout] setup error — Office Dialog APIs unavailable:", e);
          toast.info("Pop-out hors contexte Office: ouvre via le bouton dans l'extension");
        }
      });
    };

    setup();

    return () => {
      stopped = true;
      if (retryTimer) clearTimeout(retryTimer);
    };
  }, [enabled, onState]);
};

export default usePopoutBridge;
